module.exports = __webpack_public_path__ + "08671317c83b2c08491e703a3b3f135b.MP3";